// LOS DESTINOS `?ir=` · LISTO-PARA-PILOTO (b), 29 de septiembre de 2026.
//
// Los correos, el bot y el sitio mandan a `/app?ir=<clave>`. Hasta hoy
// `App.jsx` atendía tres claves (verificar, login, registro) y el resto
// —entre ellas «Darme de baja»— caía en la pantalla de acceso. La lista de
// claves vive en `destinosIr.json`, que es un DATO: la leen esta función,
// la prueba del cliente y la del servidor, así que una liga nueva en un
// correo sin su destino aquí pone la suite en rojo.
import DESTINOS from './destinosIr.json' with { type: 'json' };
import { CLAVE_MODULO } from '../lib/urlEstado';
import { reescribirUrlEn } from '../ui/navegacion';

export const TABLA = DESTINOS.destinos;

/** El destino pedido en la dirección, con su clave y sus parámetros. */
export function destinoPedido(busqueda) {
  try {
    const q = new URLSearchParams(busqueda ?? window.location.search);
    const ir = q.get('ir');
    if (!ir || !Object.prototype.hasOwnProperty.call(TABLA, ir)) return null;
    return { ir, ...TABLA[ir], t: q.get('t') || null, v: q.get('v') || null, m: q.get('m') || null };
  } catch { return null; }
}

/**
 * Un destino de pantalla de la aplicación se traduce a `?m=<módulo>`, que es
 * lo que `AppShell` ya lee al arrancar (`urlEstado.js`). Con sesión abre la
 * pantalla; sin ella, la dirección espera mientras la persona entra.
 * Devuelve el módulo si cambió la dirección.
 */
export function llevarAlModulo(busqueda) {
  const d = destinoPedido(busqueda);
  if (!d || d.tipo !== 'modulo') return null;
  try {
    const q = new URLSearchParams();
    q.set(CLAVE_MODULO, d.modulo);
    // Sin borrar el state de la entrada (TC-DR-AT): la dirección cambia, lo
    // que el módulo de navegación guarda en ella se queda.
    reescribirUrlEn(window, `${window.location.pathname}?${q.toString()}`);
  } catch { /* sin historial, se queda donde estaba */ }
  return d.modulo;
}

/** La vista de acceso pedida (`LOGIN` o `REGISTRO`), o null. */
export function entradaDelDestino(busqueda) {
  const d = destinoPedido(busqueda);
  return d && d.tipo === 'entrada' ? d.vista : null;
}

/**
 * ¿Lo atiende `PantallaDelCorreo`? La baja y las preferencias sin la llave
 * del enlace necesitan saber quién es: sin sesión, primero se entra (la
 * dirección no se toca, así que al entrar se vuelve aquí).
 */
export function pantallaDelCorreo(busqueda, autenticado) {
  const d = destinoPedido(busqueda);
  if (!d || d.tipo !== 'correo') return null;
  const pideQuien = d.vista === 'baja' || d.vista === 'preferencias';
  if (pideQuien && !d.t && !autenticado) return null;
  return d;
}
